import { EAvatarType } from '@NGUtils/enums';

const itemsKeys = {
	all: ['items'],
	wornItems: (avatarType: EAvatarType) => [...itemsKeys.all, 'wornItems', avatarType],
	inventoryItems: (avatarType: EAvatarType) => [...itemsKeys.all, 'inventoryItems', avatarType]
};

export { itemsKeys };
